<template>
    <div>
        <div class="row q-col-gutter-md">
            <div class="col col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <q-img
                    src="images/OMR-receipt.png"
                    :ratio="1"
                />
            </div>
            <div class="col col-xs-12 col-sm-12 col-md-8 col-lg-8">
                <div style="max-width: 400px; margin: 0 auto">
                    <q-list bordered>
                        <q-item class="q-pb-none">
                            <q-item-section class="col-5">
                                <q-item-label class="text-grey-7">{{$t('payment-methods.templates.amount_to_pay')}}:</q-item-label>
                            </q-item-section>

                            <q-item-section class="text-right">
                                <q-item-label>
                                    <currency-format
                                        :value="total_amount"
                                        hide-zero-decimal
                                        hide-white-spaces
                                        class="inline-block"
                                        :decimal-max-length="3"
                                    />
                                    OMR
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side style="padding-left:5px">
                                <q-btn outline
                                       dense
                                       size="sm"
                                       :label="$t('copy')"
                                       color="primary"
                                       @success="$copied($t('validations.field_is_copied', {field: $t('payment-methods.templates.amount_to_pay')}))"
                                       v-clipboard="total_amount"
                                       class="q-px-xs"
                                />
                            </q-item-section>
                        </q-item> <!-- Amount -->
                        <q-item>
                            <q-item-label caption>{{$t('payment-methods.templates.please_pay_the_exact_amount_do_not_round_this_up_down')}}</q-item-label>
                        </q-item>
                        <q-separator/>
                        <q-item>
                            <q-item-section class="col-2">
                                <q-item-label class="text-grey-7">{{$t('payment-methods.templates.name')}}:</q-item-label>
                            </q-item-section>

                            <q-item-section class="text-right">
                                <q-item-label>
                                    {{ transfer.holder }}
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side style="padding-left:5px">
                                <q-btn outline
                                       dense
                                       size="sm"
                                       :label="$t('copy')"
                                       color="primary"
                                       @success="$copied($t('validations.field_is_copied', {field: $t('payment-methods.templates.account_name')}))"
                                       v-clipboard="transfer.holder"
                                       class="q-px-xs"
                                />
                            </q-item-section>
                        </q-item> <!-- Account name -->
                        <q-separator/>
                        <q-item v-for="account in transfer.account_numbers" :key="account.address">
                            <q-item-section class="col-4">
                                <q-item-label class="text-grey-7">{{networks_map[account.network]}}:</q-item-label>
                            </q-item-section>
                            <q-item-section class="q-pt-none text-right">
                                <q-item-label>
                                    <span style="padding-right:5px">{{ account.address }}</span>
                                    <q-btn
                                        outline
                                        dense
                                        size="sm"
                                        :label="$t('copy')"
                                        color="primary"
                                        @success="copied($t('validations.field_is_copied', {field: networks_map[account.network]}))"
                                        v-clipboard="account.address"
                                        class="q-px-xs"
                                    />
                                </q-item-label>
                            </q-item-section>
                        </q-item> <!-- Account number(s) -->
                        <q-separator/>
                        <q-item>
                            <q-item-section class="col-4">
                                <q-item-label class="text-grey-7">{{$t('payment-methods.templates.remarks')}}:</q-item-label>
                            </q-item-section>

                            <q-item-section class="text-right">
                                <q-item-label>
                                    {{ transfer.remarks }}
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side style="padding-left:5px">
                                <q-btn outline
                                       dense
                                       size="sm"
                                       :label="$t('copy')"
                                       color="primary"
                                       @success="$copied($t('validations.field_is_copied', {field: $t('payment-methods.templates.remarks')}))"
                                       v-clipboard="transfer.remarks"
                                       class="q-px-xs"
                                />
                            </q-item-section>
                        </q-item> <!-- Remarks -->
                    </q-list>
                </div>
            </div> <!-- Payment Details -->
            <div class="col col-12">
                <div class="text-h6 q-mb-sm"><q-icon name="fa fa-info-circle" size="xs" color="primary" /> {{$t('payment-methods.templates.important_payment_instructions')}}:</div>
                <div v-html="instructions" class="instructions"></div>
            </div>
        </div>
        <q-dialog v-model="openDialog">
            <q-card>
                <q-card-section>
                    <div class="text-h6">{{$t('payment-methods.templates.fantastic')}}!</div>
                </q-card-section>

                <q-card-section class="q-pt-none">
                    {{$t('payment-methods.templates.our_system_gets_updated_as_soon_as_we_receive_the_payment_at_our_end')}}
                </q-card-section>

                <q-card-actions align="right">
                    <q-btn :label="$t('transfers.history')" color="primary" v-close-popup @click="$router.push({ name: 'transfers.history', query: {ref: transfer.reference}})"/>
                </q-card-actions>
            </q-card>
        </q-dialog>
    </div>
</template>
<script>

export default {
    name: "NZBankDeposit",
    props: {
        instructions: {
            type: String,
            default: ''
        },
        fee: {
            type: Number,
            default: 0
        },
        transfer: {
            type: Object,
            default: ()=>{}
        }
    },
    computed: {
        total_amount() {
            return String(this.transfer.amount + this.fee)
        }
    },
    data() {
        return {
            openDialog: false,
            networks_map: {
                ACCOUNT: this.$t('payment-methods.templates.account_number'),
                IBAN: this.$t('payment-methods.templates.iban'),
                CARD: this.$t('payment-methods.templates.card_number')
            }
        }
    },
    methods: {
        copied(message) {
            this.$q.notify({
                message: message,
                position: 'top'
            })
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {},
}
</script>
<style>
    .instructions ul{
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
